<template>
  <div id="reward" class="data-list-container vs-con-loading__container" v-if="1">
  <!-- <div id="reward" class="data-list-container vs-con-loading__container" v-if="config.gocheckin_feature == 1"> -->
     <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
          <li class="inline-flex items-end">
              <router-link to="/after-login">
                  <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
              </router-link>
              <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
          </li>
          <li class="inline-flex items-end">
            <span class="breadcrumb-separator mx-2 mb-1" style="color:#626262">Reward</span>
          </li>
      </ul>
    </div>
     <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between w-row mb-6 reward-header">
        <div class="flex add-and-history">
          <vs-button class="gradient gradient-primary no-shadow add-reward-btn" type="filled" icon-pack="feather" icon="icon-plus" @click="addNewData">Add New</vs-button>
          <router-link :to="'/reward-history'"><vs-button type="border" class="ml-6 reward-history-btn" style="background: #fff !important;">Reward History</vs-button></router-link>
        </div>
        <div class="reward-search con-input-search vs-table--search">
          <input type="text" class="input-search vs-table--search-input border-custom" @input="searchReward" placeholder="Search reward">
          <i class="vs-icon notranslate icon-scale material-icons null">search</i>
        </div>
     </div>
    <vs-table mutiple :max-items="itemsPerPage" :data="rewardsList">
       <template slot="thead">
          <vs-th class="flex justify-center">Status</vs-th>
          <vs-th class="text-center">Reward content</vs-th>
          <vs-th class="center-title text-center">Point</vs-th>
          <vs-th class="center-title text-center">Discount Value</vs-th>
          <vs-th class="center-title text-center">Actions</vs-th>
      </template>
       <template slot-scope="{data}">
         <tbody>
           <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="editData(tr),updateActiveReward(tr)">
             <vs-td>
                <div v-if="tr.is_active == 1" class="text-center">
                    <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary text-center" />
                </div>
                <div v-else class="text-center">
                    <feather-icon icon="XIcon" svgClasses="w-6 h-6 stroke-current text-danger" />
                </div>
             </vs-td>
             <vs-td>
              <p class="promotion-type font-medium truncate">{{ tr.content }}</p>
             </vs-td>
             <vs-td class="text-center">
              <p class="promotion-type font-medium truncate">{{ tr.point }}</p>
             </vs-td>
             <vs-td class="text-center">
               <div v-if="tr.logic_type=='percent'">
                  <p class="product-name font-medium truncate logic-num-font-size"><b>{{ tr.logic_value }}%</b></p>
                </div>
                <div v-else-if="tr.logic_type=='usd'">
                  <p class="product-name font-medium truncate logic-num-font-size"><b>${{ tr.logic_value }}</b></p>
                </div>
                <div v-else>
                  <p class="product-name font-medium truncate logic-num-font-size"><b>N/A</b></p>
                </div>
             </vs-td>
             <vs-td>
               <vs-row class="flex-center">
                  <!-- <vs-button @click.stop="popupActive=true, updateActiveReward(tr)" type="filled" size="small" icon-pack="feather" icon="icon-trash" color="orange" class="mr-2"></vs-button> -->
                  <img src="../../assets/images/trash-icon.png" class="trash-icon" @click.stop="popupActive=true, updateActiveReward(tr)" />
                   <vs-popup class="holamundo delete-reward-popup" title="Delete Item" :active.sync="popupActive">
                    <div class="text-center">
                      <h3>Do you want to delete item?</h3>
                      <div class="flex flex-wrap items-center align-center p-6 justify-center">
                        <vs-button class="mr-6 align-center delete-responsive" @click="deleteData">Delete</vs-button>
                        <vs-button type="border" color="danger" class="cancel-responsive" @click="popupActive=false">Cancel</vs-button>
                      </div>
                    </div>
                  </vs-popup>
                </vs-row>
             </vs-td>
           </vs-tr>
         </tbody>
       </template>
    </vs-table>
    <div v-if="rewardsData._meta.pageCount">
      <!-- <vs-pagination class="mt-6 custom-pagination" :total="parseInt(rewardsData._meta.pageCount)" v-model="currentPage"
       @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
       <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(rewardsData._meta.pageCount)"
        :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
    </div>
    <div class="update-add-sidebar">
      <vs-add-reward :addRewardConfig="addRewardConfig" :rewardData="activeRewardData" @CloseSidebar="closeSidebar" @AddReward="addReward" :key="'A' + reward_key"></vs-add-reward>
      <vs-update-reward :currentPage="currentPage" :itemsPerPage="itemsPerPage" :updateRewardConfig="updateRewardConfig" @UpdateReward="updateReward"
      :rewardData="activeRewardData" :sidebarData="sidebarData" @CloseUpdateReward="closeSidebar" :key="'B' + reward_key"></vs-update-reward>
    </div>
  </div>
  <div v-else>
    <vx-card>
      <h2>
        This is for Go Check In full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
  </div>
</template>

<script>
export default {
  // props: {
  //   dataChange: {
  //     type: Object
  //   }
  // },
  data(){
    return {
      popupActive: false,
      currentPage: 1,
      itemsPerPage: 10,
      search: '',
      sidebarData: {},
      activeRewardData : {},
      sidebarConfig: {
        isOpen: false
      },
      addRewardConfig:{
        isOpen: false
      },
      updateRewardConfig:{
        isOpen: false
      },
      items: [
        {
          title: 'Home',
          url: '/',
          icon: "HomeIcon",
        },
        {
          title: 'Reward',
          active: true,
        },
      ],
      action_type: '',
      isOpenLoading: false,
      page_key: 0,
      loaded_data_num: 0,
      reward_key: 0,
    };
  },
  watch: {
  //   dataChange: {
  //     immediate: true,
  //     deep: true,
  //     handler: function () {
  //       // if(this.dataChange) {
  //       //   console.log(this.dataChange.message);
  //       // }
  //       // if(this.dataChange && this.dataChange.message == 'afterInsert') {
  //       if(this.dataChange) {
  //         const obj = {
  //           page: this.currentPage,
  //           "per-page": this.itemsPerPage,
  //           content: this.search,
  //         }
  //         this.$store.dispatch("rewardList/GET_REWARD_LIST", obj)
  //       }
  //     },
  //   }
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    }
  },
  computed:{
    rewardsData(){
      return this.$store.state.rewardList.rewardData;
    },
    rewardsList(){
      return this.$store.state.rewardList.rewardList;
    },
    config() {
      return this.$store.getters["auth/config"];
    }
  },
  methods:{
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' reward failed',
            acceptText: 'OK'
          })
        }
      }, 10000);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    searchReward({target}){
      this.currentPage = 1;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.action_type = 'Search';
      if(!this.isOpenLoading){
        this.openLoadingInDiv();
      }
      this.timer = setTimeout(() => {
        this.search = target.value;
        const obj={
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          content: target.value
        }
        this.$store.dispatch('rewardList/GET_REWARD_LIST',obj).then(() => {
          this.closeLoading();
        })
      }, 500);
    },
    deleteData(){
      const obj = {
        id: this.sidebarData.id,
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        content: this.search,
      }
      this.action_type = 'Delete';
      this.openLoadingInDiv();
      this.$store.dispatch("rewardList/DELETE_REWARD" ,obj).then(() => {
        this.closeLoading();
        this.$vs.notify({
        title:'Notification',
        text:'Delete Reward Success',
        color:'success',
        position:'top-right'})
      })
      this.popupActive = false;
    },
    updateReward(data){
      this.action_type = 'Update';
      this.openLoadingInDiv();
       this.$store.dispatch("rewardList/UPDATE_REWARD" ,data).then(() => {
         this.closeSidebar();
         this.closeLoading();
         this.$vs.notify({
          title:'Notification',
          text:'Update Reward Success',
          color:'success',
          position:'top-right'})
      }).catch((err) => console.log(err))
    },
    editData(data){
      this.reward_key++;
      this.sidebarData = data,
      this.updateRewardConfig.isOpen = true;
    },
    updateActiveReward(tr){
      this.sidebarData = tr;
    },
    addNewData() {
      this.reward_key++;
      this.sidebarData = {}
      this.addRewardConfig.isOpen = true;
    },
    closeSidebar(){
      // this.reward_key++;
      this.addRewardConfig.isOpen = false;
      this.updateRewardConfig.isOpen = false;
      document.getElementById("reward").click();
    },
    addReward(data){
      window.scrollTo(0,1);
      this.action_type = 'Add';
      this.openLoadingInDiv();
      this.$store.dispatch("rewardList/ADD_REWARD" ,data).then(() => {
        this.closeSidebar();
        this.closeLoading();
        this.$vs.notify({
          title:'Notification',
          text:'Add Reward Success',
          color:'success',
          position:'top-right'})
      })
    },
    changePage(currentPage){
      const obj = {
          page: currentPage,
          "per-page": this.itemsPerPage,
          content: this.search
      }
      this.action_type = 'Get list'
      this.openLoadingInDiv();
      this.$store.dispatch("rewardList/GET_REWARD_LIST", obj).then(() => {
        this.closeLoading();
        this.page_key++;
        this.currentPage = currentPage;
      })
    },
    subcribeTopic(){
      const obj = {
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        content: this.search,
      }
      this.$store.dispatch("rewardList/GET_REWARD_LIST", obj).then(() => {
        this.loaded_data_num++;
      })
    }
  },
  created(){
    this.subcribeTopic();
  },
   mounted() {
    this.isMounted = true;
  }
}
</script>
